import { createStore } from 'vuex'
import axios from "axios";

export default createStore({
  state: {
    authenticated: false, // wheather the user is logged in
    errorText: "", // the text for error
    warningText: "", // the text for warning
    successText: "", // the text for success pop
    infoText: "", // the text for info pop
    showWarning: false, // to show warning or not
    showError: false,
    showSuccess: false,
    showInfo: false,
    userData: { userName: "xxx", birthday: "1900-01-01" },

    // for getting the posts on board
    seenPostIDs: new Set(),
    seenGrids: new Set(),
    postList: [],

    // grid size;
    gridSize: 3000,

    // the center position
    centerX: 0,
    centerY: 0,
    moveToCenter: false,
  },
  getters: {
    authenticated: state => state.authenticated, // get wheather user is authenticated
    warningText: state => state.warningText,
    errorText: state => state.errorText,
    successText: state => state.successText,
    infoText: state => state.infoText,
    showWarning: state => state.showWarning,
    showError: state => state.showError,
    showSuccess: state => state.showSuccess,
    showInfo: state => state.showInfo,
    userData: state => state.userData,
    seenPostIDs: state => state.seenPostIDs,
    seenGrids: state => state.seenGrids,
    foreignObjectList: state => state.foreignObjectList,
    postList: state => state.postList,
    gridSize: state => state.gridSize,
    moveToCenter: state => state.moveToCenter,
    centerX: state => state.centerX,
    centerY: state => state.centerY,
  },
  mutations: {
    SET_AUTHENTICATED(state, authenticated) {
      // set authenticated
      state.authenticated = authenticated
    },
    SET_SHOWWARNING(state, show) {
      state.showWarning = show;
    },
    SET_SHOWERROR(state, show) {
      state.showError = show;
    },
    SET_SHOWSUCCESS(state, show) {
      state.showSuccess = show;
    },
    SET_SHOWINFO(state, show) {
      state.showInfo = show;
    },
    SET_WARNINGTEXT(state, text) {
      state.warningText = text;
    },
    SET_ERRORTEXT(state, text) {
      state.errorText = text;
    },
    SET_SUCCESSTEXT(state, text) {
      state.successText = text;
    },
    SET_INFOTEXT(state, text) {
      state.infoText = text;
    },
    SET_USERDATA(state, data) {
      state.userData = data;
    },
    ADD_SEENPOSTIDS(state, id) {
      state.seenPostIDs.add(id);
    },
    ADD_SEENGRIDS(state, grid) {
      state.seenGrids.add(grid);
    },
    ADD_POST(state, post) {
      state.postList.push(post);
    },
    SET_LASTPOSTTIME(state, time) {
      state.userData.lastPostTime = time;
    },
    LIKE_POST(state, id) {
      const ind = state.userData.likedPosts.indexOf(id);
      if (ind != -1) {
        // has liked this post, remove it
        state.userData.likedPosts.splice(ind, 1);
      } else {
        state.userData.likedPosts.push(id);
      }
    },
    DISLIKE_POST(state, id) {
      const ind = state.userData.dislikedPosts.indexOf(id);
      if (ind != -1) {
        // has liked this post, remove it
        state.userData.dislikedPosts.splice(ind, 1);
      } else {
        state.userData.dislikedPosts.push(id);
      }
    },
    SET_MOVETOCENTER(state, move) {
      state.moveToCenter = move;
    },
    SET_CENTERX(state, x) {
      state.centerX = x;
    },
    SET_CENTERY(state, y) {
      state.centerY = y;
    }
  },
  actions: {
    setAuthenticated(context, authenticated) {
      // set authentication
      context.commit("SET_AUTHENTICATED", authenticated);
    },
    setWarning(context, text) {
      context.commit("SET_SHOWWARNING", true);
      context.commit("SET_WARNINGTEXT", text)
    },
    setError(context, text) {
      context.commit("SET_SHOWERROR", true);
      context.commit("SET_ERRORTEXT", text)
    },
    setSuccess(context, text) {
      context.commit("SET_SHOWSUCCESS", true);
      context.commit("SET_SUCCESSTEXT", text)
    },
    setInfo(context, text) {
      context.commit("SET_SHOWINFO", true);
      context.commit("SET_INFOTEXT", text);
    },
    setWarningOff(context) {
      context.commit("SET_SHOWWARNING", false);
    },
    setErrorOff(context) {
      context.commit("SET_SHOWERROR", false);
    },
    setSuccessOff(context) {
      context.commit("SET_SHOWSUCCESS", false);
    },
    setInfoOff(context) {
      context.commit("SET_SHOWINFO", false);
    },
    setUserData(context, data) {
      context.commit("SET_USERDATA", data);
    },
    setLastPostTime(context, time) {
      context.commit("SET_LASTPOSTTIME", time);
    },
    tryLogin(context) {
      if (!this.state.authenticated) {
        // try to log in with the cookie we have
        var config = {
          method: "get",
          url: "http://138.197.71.184:5001/user",
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios(config)
          .then(function (response) {
            context.commit("SET_AUTHENTICATED", true);
            context.commit("SET_USERDATA", response.data);
          })
          .catch(function (error) {
            context.commit("SET_AUTHENTICATED", false);
            console.log(error);
          });
      }
    },
    addSeenPostIDs(context, id) {
      context.commit("ADD_SEENPOSTIDS", id);
    },
    addSeenGrids(context, grid) {
      context.commit("ADD_SEENGRIDS", grid);
    },
    addPost(context, post) {
      context.commit("ADD_POST", post);
    },
    async getGridPostIDs({ commit, state }, grids) {
      var postList = [];
      for (const grid of grids) {
        var config = {
          method: "get",
          url: "http://138.197.71.184:5001/grid?x=" + grid.xIndex + "&y=" + grid.yIndex,
          headers: {
            "Content-Type": "application/json",
          },
        };
        try {
          let res = await axios(config);
          if (res.status == 200) {
            if (res.data.posts) {
              for (const postID of res.data.posts) {
                if (!state.seenPostIDs.has(postID)) {
                  commit("ADD_SEENPOSTIDS", postID);
                  postList.push(postID);
                }
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
      return postList;
    },
    async getPosts({ commit }, postList) {
      for (const postID of postList) {
        var config = {
          method: "get",
          url: "http://138.197.71.184:5001/post?id=" + postID,
          headers: {
            "Content-Type": "application/json",
          },
        };
        try {
          let res = await axios(config);
          if (res.status == 200) {
            commit("ADD_POST", res.data);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getAllPostsInGrids({ dispatch }, grids) {
      const postList = await dispatch('getGridPostIDs', grids);
      if (postList.length != 0) {
        dispatch("setInfo", "Loading posts, please be patient");
        dispatch('getPosts', postList);
      }
    },
    like_post({ commit }, id) {
      commit("LIKE_POST", id);
    },
    dislike_post({ commit }, id) {
      commit("DISLIKE_POST", id);
    },
    setMoveToCenter({ commit }, pos) {
      commit("SET_CENTERX", pos.x);
      commit("SET_CENTERY", pos.y);
      commit("SET_MOVETOCENTER", true);
    },
    fufillMoveToCenter({ commit }) {
      // commit("SET_CENTERX", 0);
      // commit("SET_CENTERY", 0);
      commit("SET_MOVETOCENTER", false);
    }
  },
  modules: {
  }
})
